import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
import { LifetimePartnerForm } from '../components/Payment/LifetimePartnerForm';
import { PaystackScript } from '../components/Payment/PaystackScript';
import { Check, ArrowRight, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
export const LifetimePartner = () => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success' | 'form'>('pending');
  const [reference, setReference] = useState('');
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('form');
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    fetch('https://formspree.io/f/mldpapna', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        setPaymentStatus('success');
        // Redirect to WhatsApp group
        window.location.href = 'https://chat.whatsapp.com/BslF3e6Z9hk4ar8agDfQ51';
      } else {
        throw new Error('Form submission failed');
      }
    }).catch(error => {
      console.error('Error:', error);
      // Handle error state
    });
  };
  if (paymentStatus === 'success') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3752" data-mp="3v44dkoydfhor">
        <div className="container mx-auto px-4 py-16" data-id="element-3753" data-mp="3v4xdb5ywx6xe">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3754" data-mp="3qcmbtyoixd2q">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3755" data-mp="3qb2us5v1mxzw">
              <Check size={40} className="text-gray-700" data-id="element-3756" data-mp="3geq0b5rocg43" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3757" data-mp="3gcn587bnzwsi">
              Welcome to The Networking Salon Lifetime Partner Access!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3758" data-mp="37fcq2avq7nib">
              Thank you for joining our community. Your registration was
              successful.
            </p>
            <p className="text-gray-600 mb-12" data-id="element-3759" data-mp="31size77k4t8s">
              We're redirecting you to our WhatsApp community...
            </p>
          </div>
        </div>
      </div>;
  }
  if (paymentStatus === 'form') {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3760" data-mp="2sqjj5h4d9t6w">
        <div className="container mx-auto px-4 py-16" data-id="element-3761" data-mp="2st5yi2xi1czo">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3762" data-mp="3ghyq5n738yoh">
            <div className="inline-block w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-3763" data-mp="3lfqoayybth14">
              <Check size={40} className="text-gray-700" data-id="element-3764" data-mp="36rvx5mzyvkq5" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-3765" data-mp="3bq72plj8b92k">
              Payment Successful!
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3766" data-mp="39cdh8vctn6y">
              Please complete your registration to join The Networking Salon as
              a Lifetime Partner.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-3767" data-mp="1sqzf7a0oty5f">
              Reference ID: <span className="font-medium" data-id="element-3768" data-mp="1spepbxpbj3dw">{reference}</span>
            </p>
          </div>
          <div className="max-w-2xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3769" data-mp="1nqbt92rbg7i2">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3770" data-mp="21j1f976uhcf6">
              Complete Your Registration
            </h2>
            <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-3771" data-mp="19sn43iq7ue77">
              <input type="hidden" name="payment_reference" value={reference} data-id="element-3772" data-mp="19sww1butmvfj" />
              <div data-id="element-3773" data-mp="14v4vjtg420zq">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3774" data-mp="14vn1jhskrtku">
                  Full Name <span className="text-gray-500" data-id="element-3775" data-mp="1iuwfsbx80dm6">(required)</span>
                </label>
                <input type="text" name="name" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3776" data-mp="1dtgs0c3nrt03" />
              </div>
              <div data-id="element-3777" data-mp="2p9faf6kq7rdz">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3778" data-mp="2p9x2dr0cvjg3">
                  Email <span className="text-gray-500" data-id="element-3779" data-mp="3kjljyn8dqf4s">(required)</span>
                </label>
                <input type="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3780" data-mp="3klyb9r0121ui" />
              </div>
              <div data-id="element-3781" data-mp="3ugq7aqdyogn6">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3782" data-mp="3ug6oz8kefq8m">
                  Phone Number <span className="text-gray-500" data-id="element-3783" data-mp="3c88zygg1fyk">(required)</span>
                </label>
                <input type="tel" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3784" data-mp="7c0lgm8yk697" />
              </div>
              <div data-id="element-3785" data-mp="ca21szf01rgz">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3786" data-mp="h2v5rl2n8vs0">
                  Business/Organization{' '}
                  <span className="text-gray-500" data-id="element-3787" data-mp="m2hkjyy4ek2x">(if applicable)</span>
                </label>
                <input type="text" name="business" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3788" data-mp="r1kr5ntr0yd0" />
              </div>
              <div data-id="element-3789" data-mp="v3604y35wshx">
                <label className="block text-gray-700 font-medium mb-1" data-id="element-3790" data-mp="v0ju52vx6l1t">
                  What are your main goals for joining as a Lifetime Partner?{' '}
                  <span className="text-gray-500" data-id="element-3791" data-mp="2bi0ntxobqo8i">(required)</span>
                </label>
                <textarea name="goals" required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md" data-id="element-3792" data-mp="26j7961xawr6r" />
              </div>
              <div data-id="element-3793" data-mp="21mqjh3age4rk">
                <Button type="submit" className="w-full" data-id="element-3794" data-mp="21n8r0w2kg5es">
                  Complete Registration
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white" data-id="element-3795" data-mp="2piux0ij74t88">
      <PaystackScript data-id="element-3796" data-mp="2phtc7mcdosdb" />
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3797" data-mp="2pgi81lf0tilo">
        <div className="absolute inset-0 z-0" data-id="element-3798" data-mp="2kj8je7zghayw">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3799" data-mp="3hyvy2yu480a7" />
          <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-3800" data-mp="3d6md7x7uxqes"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3801" data-mp="1bczvsahv3d0o">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3802" data-mp="1fb736eqfr1z7">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3803" data-mp="11lc01xe9v9te">
              LIFETIME PARTNER ACCESS
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3804" data-mp="16i2fcii961dr">
              Join the Circle of Builders
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3805" data-mp="wmioiaijpsvv">
              Strategic partnerships for founders, leaders, and visionaries who
              see relationships as strategy and community as an accelerator for
              growth.
            </p>
            <Button className="text-lg px-8 py-4" onClick={() => {
            setShowPaymentForm(true);
            setTimeout(() => {
              const element = document.getElementById('payment-form');
              if (element) {
                element.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 100);
          }} data-id="element-3806" data-mp="nnf2axo30xd5">
              Get Lifetime Partner Access (₦50,000)
            </Button>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-3807" data-mp="2w545265k6zs4">
        <div className="container mx-auto px-4" data-id="element-3808" data-mp="2w3t0430dnlzf">
          <div className="max-w-3xl mx-auto" data-id="element-3809" data-mp="2w318f39wi8ef">
            <div className="border-2 border-gray-300 rounded-lg p-8 mb-12" data-id="element-3810" data-mp="3asp9q4i31725">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center" data-id="element-3811" data-mp="35v6xa44uw9pe">
                🌟 The Networking Salon — Lifetime Partner Access
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3812" data-mp="3js3x2v2yd1if">
                Welcome to the Circle of Builders.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3813" data-mp="1pg5mopswpzky">
                Lifetime Partner Access is designed for those who don't just
                want to network — they want to build. It's for founders,
                leaders, and visionaries who see relationships as strategy and
                community as an accelerator for growth.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3814" data-mp="2exabse39m1ko">
                This tier is for the few who want a deeper seat at the table —
                where ideas become action, projects get personalized support,
                and your brand becomes part of the story we're building
                together.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3815" data-mp="1r2zactnwmpje">
                💼 What Lifetime Partner Access Offers
              </h3>
              <div className="space-y-4 mb-8" data-id="element-3816" data-mp="2012r7cny2y4v">
                <div className="flex items-start" data-id="element-3817" data-mp="2009meh8jqipd">
                  <span className="mr-2" data-id="element-3818" data-mp="250xl7p30o3u5">🎯</span>
                  <div data-id="element-3819" data-mp="24ykscgvq092b">
                    <p className="font-bold text-gray-800" data-id="element-3820" data-mp="3bgre64177x5o">
                      One-on-One Strategic Guidance
                    </p>
                    <p className="text-gray-700" data-id="element-3821" data-mp="3get0qyxu2elw">
                      Personalized sessions to refine your goals, business
                      models, or growth strategy — with hands-on guidance
                      tailored to your unique journey.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3822" data-mp="3gseo467h3zvt">
                  <span className="mr-2" data-id="element-3823" data-mp="3csw73lirw8y9">💡</span>
                  <div data-id="element-3824" data-mp="3cs4aq8hcq76x">
                    <p className="font-bold text-gray-800" data-id="element-3825" data-mp="3cqjod656xuk5">
                      Project & Business Handholding
                    </p>
                    <p className="text-gray-700" data-id="element-3826" data-mp="32tx5gmwfddkr">
                      Get ongoing support on your individual or organizational
                      projects. We help you move from ideas to execution with
                      structure, accountability, and access to tools that work.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3827" data-mp="w1eay8w3fyje">
                  <span className="mr-2" data-id="element-3828" data-mp="s36uzg9gf199">🧠</span>
                  <div data-id="element-3829" data-mp="s0ax1rxlwckt">
                    <p className="font-bold text-gray-800" data-id="element-3830" data-mp="xnqp9bf5hd07">
                      Access to Advanced Masterminds
                    </p>
                    <p className="text-gray-700" data-id="element-3831" data-mp="tm55d6477ygi">
                      Join curated mastermind circles that bring together
                      high-performing entrepreneurs, creators, and executives
                      focused on intentional growth and collective intelligence.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3832" data-mp="9yz3b1s5lqvv">
                  <span className="mr-2" data-id="element-3833" data-mp="a0a9f892naq5">🌍</span>
                  <div data-id="element-3834" data-mp="onbsnfwqkbhe">
                    <p className="font-bold text-gray-800" data-id="element-3835" data-mp="oon5e585stkn">
                      Brand Visibility & Features
                    </p>
                    <p className="text-gray-700" data-id="element-3836" data-mp="jvka9snqhc2c">
                      Showcase your brand, initiative, or business across The
                      Networking Salon website and platforms. Your work deserves
                      to be seen — by the right people.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3837" data-mp="27lzwa562gnxv">
                  <span className="mr-2" data-id="element-3838" data-mp="27nugtidfee1f">🎟️</span>
                  <div data-id="element-3839" data-mp="1tv4wdidjph6f">
                    <p className="font-bold text-gray-800" data-id="element-3840" data-mp="1tvwgnx1ozshe">
                      Exclusive Event Benefits
                    </p>
                    <p className="text-gray-700" data-id="element-3841" data-mp="1xwq28jrnwv74">
                      Enjoy lifetime discounts on all in-person events and
                      experiences hosted by The Networking Salon — from private
                      dinners to public summits.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-3842" data-mp="2cnp6jilgsxkw">
                  <span className="mr-2" data-id="element-3843" data-mp="2hj4ksbndwvhu">🗂️</span>
                  <div data-id="element-3844" data-mp="1167cjatorcbk">
                    <p className="font-bold text-gray-800" data-id="element-3845" data-mp="115o3kjm0jy9o">
                      Resource Catalogue Access
                    </p>
                    <p className="text-gray-700" data-id="element-3846" data-mp="166vegrjgddkk">
                      Gain full access to our growing library of templates,
                      strategy tools, and playbooks that simplify
                      decision-making and amplify your impact.
                    </p>
                  </div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3847" data-mp="2u31i2hotouww">
                💎 Your Investment
              </h3>
              <div className="bg-gray-100 p-6 rounded-lg mb-8 text-center" data-id="element-3848" data-mp="2p4hy2mtsht76">
                <p className="text-2xl font-bold text-gray-800 mb-2" data-id="element-3849" data-mp="2k4vkuddyocyd">
                  ₦100,000 — Lifetime Access
                </p>
                <p className="text-gray-700 italic" data-id="element-3850" data-mp="2f6u07o0w05ks">
                  (Currently discounted to ₦50,000)
                </p>
                <p className="text-gray-700 mt-4" data-id="element-3851" data-mp="2b5s074z5bphr">
                  This is a one-time investment for those ready to grow
                  intentionally, connect deeply, and align with a network built
                  for impact.
                </p>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3852" data-mp="1r9e7l0f0f8d4">
                🌿 Why Become a Lifetime Partner
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3853" data-mp="1w7pk5iwovwz1">
                Becoming a Lifetime Partner means joining a circle of committed
                individuals shaping what The Networking Salon stands for —
                collaboration, generosity, and transformation.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-3854" data-mp="18d5yflivmdcj">
                You're not just gaining access — you're becoming a foundational
                voice in a movement that bridges people, purpose, and
                possibility.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-3855" data-mp="1mb4bmnlgo3qg">
                This is more than membership. It's partnership — for life. Your
                seat at the table is ready.
              </p>
            </div>
            {showPaymentForm && <div id="payment-form" className="border-2 border-gray-300 rounded-lg p-8" data-id="element-3856" data-mp="2xphxxo0kgb4d">
                <LifetimePartnerForm onSuccess={handleSuccess} data-id="element-3857" data-mp="2w8kmfab1o7k8" />
              </div>}
          </div>
        </div>
      </section>
    </div>;
};